(function () {
    'use strict';

    angular
        .module('app.systemLog')
        .controller('SystemLogCtrl', SystemLogCtrl);

        SystemLogCtrl.$inject = ['$scope', '$rootScope', '$http', '$modal', '$stateParams', 'systemLogService', 'adminService'];
        function SystemLogCtrl($scope, $rootScope, $http, $modal, $stateParams, systemLogService, adminService) 
        {
            $scope.flag = false;
            $scope.currentPage = 1;
            $scope.pageSize = 25;
            $scope.systemlogs = [];
            $scope.searchString = null;
            $scope.account_user_name = null;
            $scope.typeOfLog = null;
            $scope.flagShowBlock = true
            $scope.flagShowTitle = false;

            $scope.sendHttpRequest = function ()
            {
                var result = null;
                if($stateParams.accountDataLog != null)
                {
                    $scope.flagShowTitle = true;
                    $scope.flagShowBlock = false;
                    $scope.company = $stateParams.accountDataLog.index;
                    $scope.account_user_name = $scope.company.name;
                    $scope.typeOfLog = "User and Billing > Account Log"
                    var params = {
                        companyId: $stateParams.accountDataLog.index.id,
                        searchString: $scope.searchString,
                        pageNo: $scope.currentPage
                    }

                    systemLogService.searchAccountLog(params)
                        .then(function(result){
                            $scope.loadData(result);
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                        });
                }
                else if($stateParams.userDataLog != null)
                {
                    $scope.flagShowTitle = true;
                    $scope.flagShowBlock = false;
                    $scope.user = $stateParams.userDataLog.index;
                    $scope.account_user_name = $scope.user.firstName + " " + $scope.user.lastName;
                    $scope.typeOfLog = "User and Billing > User Log"
                    var params = {
                        userId: $stateParams.userDataLog.index.id,
                        searchString: $scope.searchString,
                        pageNo: $scope.currentPage
                    }
                    systemLogService.searchUserLog(params).then(function(result){
                            $scope.loadData(result);
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                        });
                }
                else
                {
                    $scope.flagShowTitle = false;
                    $scope.flagShowBlock = true;
                    $scope.typeOfLog = "System Log";
                    var params = {
                        searchString: $scope.searchString,
                        pageNo: $scope.currentPage
                    }
                    systemLogService.searchSystemLog(params).then(function(result){
                            $scope.loadData(result);
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                        });
                }
            }

            $scope.loadData = function(result)
            {
                $scope.systemlogs = result.data;
                $scope.totalRow = result.totalRow;
                $scope.pagination();
                $scope.flag = true;
            }

            if(!$scope.flag)
            {
                $scope.sendHttpRequest();
            }

            $scope.pagination = function()
            {
                $scope.pages = adminService.pagination($scope.totalRow, $scope.pageSize);
            }

            $scope.updatePage = function(val)
            {
                $scope.currentPage = val;
                $scope.sendHttpRequest();
            }

            $scope.searchSystemLog = function()
            {
                $scope.currentPage = 1;
                $scope.sendHttpRequest();
            }
        }
})();